/**
 * Single source of truth for localStorage keys
 * Add/remove properties here - everything else auto-updates
 */
export const localStorageAccessConstant = {
    icao: 'icao',
    fbo: 'fbo',
    fboId: 'fboId',
    conductorFbo: 'conductorFbo',
    groupId: 'groupId',
    impersonatedrole: 'impersonatedrole',
    managerGroupId: 'managerGroupId',
    favoriteAircrafts: 'favoriteAircrafts',
    accountType: 'accountType',
    dismissedFavoriteAircrafts: 'dismissedFavoriteAircrafts',
    notifiedFavoriteAircraft: 'notifiedFavoriteAircraft',
    isSingleSourceFbo: 'isSingleSourceFbo',
    isNetworkFbo: 'isNetworkFbo',
    currentUser: 'currentUser',
    decimalPrecision: 'decimalPrecision',
    isJetNetIntegrationEnabled: 'isJetNetIntegrationEnabled',
    refreshToken: 'refreshToken',
    isNewFbo: 'isNewFbo',
    dashboardSettings: 'dashboardSettings',
    analyticsSettings: 'analyticsSettings',
    permitedRoles: 'permitedRoles',
    isFboSelected: 'isFboSelected'
} as const;

/**
 * Type for localStorage constant keys - prevents typos
 * Usage: localStorageAccessConstant.icao (not 'icao')
 */
export type LocalStorageKey = keyof typeof localStorageAccessConstant;

/**
 * Type mapping for value types
 * Defines what type each key returns
 * Add/remove properties here when updating localStorageAccessConstant
 */
export type LocalStorageValueType = {
    icao: string | null;
    fbo: string | null;
    fboId: number | null;
    conductorFbo: boolean | null;
    groupId: number | null;
    impersonatedrole: string | null;
    managerGroupId: number | null;
    favoriteAircrafts: any | null;
    accountType: number | null;
    dismissedFavoriteAircrafts: any | null;
    notifiedFavoriteAircraft: any | null;
    isSingleSourceFbo: boolean | null;
    isNetworkFbo: boolean | null;
    currentUser: any | null;
    decimalPrecision: number | null;
    isJetNetIntegrationEnabled: boolean | null;
    refreshToken: string | null;
    isNewFbo: boolean | null;
    dashboardSettings: any | null;
    analyticsSettings: any | null;
    permitedRoles: any | null;
    isFboSelected: boolean | null;
};

/**
 * Complete user context - automatically typed from LocalStorageValueType
 * All properties from localStorageAccessConstant with their correct types
 */
export type UserContext = LocalStorageValueType;